module.exports = __webpack_public_path__ + "img/noProducts.cc89e723.png";